import {
  REQUEST_LIST, 
  REQUEST_LIST_SUCCESS, 
  REQUEST_LIST_ERROR,
  REQUEST_SEARCH_SET, 
  REQUEST_SEARCH_CHANGE, 
  REQUEST_PAGE_SET,
  REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT,
  REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  REQUEST_ADD_SET,
  REQUEST_ADD_MODAL_SET,
  REQUEST_ADD,
  REQUEST_ADD_SUCCESS,
  REQUEST_ADD_ERROR,
  REQUEST_ADD_CHANGE,
  REQUEST_DETAIL,
  REQUEST_DETAIL_SUCCESS,
  REQUEST_DETAIL_ERROR,
  REQUEST_VIEW_MODAL_SET,
  REQUEST_EDIT_CHANGE,
  REQUEST_EDIT_MODAL_SET,
  REQUEST_UPDATE,
  REQUEST_UPDATE_SUCCESS,
  REQUEST_UPDATE_ERROR,
  REQUEST_VIEW_TAB_SET,
  REQUEST_UPLOAD_SET,
  REQUEST_UPLOAD_SET_SUCCESS,
  REQUEST_UPLOAD_SET_ERROR,
  REQUEST_UPLOAD_RESET
} from '../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 5
    }
  },
  add: {
      data: {
        new:{ delivery_order_line_lot: null, id_delivery_order_line_lot: null, id_request_type: null, id_request_type_detail: null, id_priority: null, id_hospital_service: null, id_hospital_section: null, request_date: null, title: null, location: null, description: null}
      },
      modal: false,
      loading: false,
      message: '',
      url: '',
      type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      delivery_order_line_lot: false
    },
    value:{
      delivery_order_line_lot: false,
    },
    delivery_order_line_lot:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case REQUEST_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case REQUEST_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case REQUEST_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case REQUEST_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case REQUEST_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case REQUEST_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          delivery_order_line_lot:{
            ...state.search.delivery_order_line_lot,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          delivery_order_line_lot:{
            ...state.search.delivery_order_line_lot,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          delivery_order_line_lot:{
            ...state.search.delivery_order_line_lot,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case REQUEST_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case REQUEST_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case REQUEST_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new:{ delivery_order_line_lot: null, id_delivery_order_line_lot: null, id_request_type: null, id_request_type_detail: null, id_priority: null, id_hospital_service: null, id_hospital_section: null, request_date: null, title: null, location: null, description: null}
          },
          modal: action.payload
        }
      }
    case REQUEST_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case REQUEST_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case REQUEST_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case REQUEST_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true
        }
      }
    case REQUEST_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case REQUEST_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    case REQUEST_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case REQUEST_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case REQUEST_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case REQUEST_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case REQUEST_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case REQUEST_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case REQUEST_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    case REQUEST_UPLOAD_SET:
      return { ...state };
    case REQUEST_UPLOAD_SET_SUCCESS:
      return {
        ...state,
        file: [...state.file, action.payload]
      };
    case REQUEST_UPLOAD_SET_ERROR:
      return { 
        ...state,
        file: [...state.file, action.payload]
      };
    case REQUEST_UPLOAD_RESET:
      return {
        ...state,
        file: []
      };
    default:
      return { ...state };
    }

};